module.exports = __webpack_public_path__ + "img/gyr.57e5239a.png";